function getDateString(date: Date): string {
  const day = parseInt(date.toLocaleDateString('en-US', { day: 'numeric' }))
  const ordinalDaySuffix = `${
    day === 1 || day === 21 || day === 31
      ? 'st'
      : day === 2 || day === 22
      ? 'nd'
      : day === 3 || day === 23
      ? 'rd'
      : 'th'
  }`
  const month = date.toLocaleDateString('en-US', { month: 'long' })
  const year = date.toLocaleDateString('en-US', { year: 'numeric' })
  return `${month} ${day}${ordinalDaySuffix}, ${year}`
}

function isToday(date: Date): boolean {
  const today = new Date()
  const isToday =
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  return isToday
}

const calculateDaysAgo = (date: Date) => {
  if (isToday(date)) {
    return 0
  } else {
    const today = new Date()
    let daysAgo = Math.trunc((today.getTime() - date.getTime()) / (24 * 60 * 60 * 1000))
    daysAgo = daysAgo === 0 ? 1 : daysAgo
    return daysAgo
  }
}

function getDateTimeString(date: Date): string {
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  })
}

export { getDateString, getDateTimeString, isToday, calculateDaysAgo }
